import store from "@/store";

export default {
    install(app) {
        app.config.errorHandler = function(error, vm) {
            const componentName = vm.__isVue
                ? vm.$options.name || vm.$options._componentTag
                : vm.name;

            store.commit("error/setError", {
                hard: true,
                details: {
                    message: typeof error === "string" ? error : error.message,
                    source: componentName,
                    stack:
                        error === null
                            ? null
                            : error.stack || error.stacktrace || null
                }
            });
        };

        window.onunhandledrejection = function({ reason, type }) {
            store.commit("error/setError", {
                hard: true,
                details: {
                    message:
                        typeof reason === "string" ? reason : reason.message,
                    source: type,
                    stack:
                        reason === null
                            ? null
                            : reason.stack || reason.stacktrace || null
                }
            });
        };

        window.onerror = function(message, source, _lineno, _colno, error) {
            if (message === "Script error.") {
                // Script error is the error that is thrown when cross-domain errors occur
                // https://blog.sentry.io/2016/05/17/what-is-script-error
                //
                // Do not block the UI, as the user probably still can continue, as the only
                // cross domain script being used is third party tracking scripts
            } else {
                store.commit("error/setError", {
                    hard: true,
                    details: {
                        message: message,
                        source: source,
                        stack:
                            error === null
                                ? null
                                : error.stack || error.stacktrace || null
                    }
                });
            }
        };
    }
};
